import { useQuery } from '@tanstack/react-query';
import { getContactById } from '../api/crmApi';

export const contactDetailKeys = {
  all: ['crm-contact-detail'] as const,
  detail: (id: string) => [...contactDetailKeys.all, id] as const,
};

export function useContactDetail(id: string) {
  return useQuery({
    queryKey: contactDetailKeys.detail(id),
    queryFn: () => getContactById(id),
    staleTime: 2 * 60 * 1000,
    enabled: !!id,
  });
}
